import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { DsAnnuciatorIP, MultiOptDetails_5DS, SaveEventType, SaveStatusObj, SOModule, UserType, ValidationItem, ValidationSummary } from '../../../../shared/misc-classes';
import { DataService } from '../../../../shared/dataservice.service';
import { ValidationDialog } from '../../../../dialogs/validation-dialog/validation-dialog';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

@Component({
  selector: 'ds-annuciator',
  templateUrl: './ds-annuciator.component.html',
  styleUrls: ['./ds-annuciator.component.css']
})
export class DsAnnuciatorComponent implements OnInit, OnChanges {

  @Input() dsAnnuciatorObj: DsAnnuciatorIP;
  @Input() soLockObtained: boolean;
  @Input() accessLevel: Array<UserType>;
  @Output() updateDatasheet: EventEmitter<SaveStatusObj> = new EventEmitter();

  disableForm: boolean = false;
  inputDisableMessage: string = 'This form is not yet enabled';
  readonlyAccess: boolean = false;
  Hvr: any = {};
  hasAccessEE: boolean = false;
  hasAccessME: boolean = false;
  hasAccessPM: boolean = false;
  lockFields: boolean = false; // After HOM lock

  constructor(public _dataService: DataService, public dialog: MatDialog) { }

  ngOnInit(): void {
  }
  ngOnChanges(): void {
    this.disableForm = true;
    if (this.soLockObtained == false) {
      this.inputDisableMessage = "You can't Edit";
    }
    else if (this.accessLevel.includes(this._dataService.userType) == false) {
      this.inputDisableMessage = "You don't have EDIT ACCESS.";
    }
    else {
      this.disableForm = false;
      // this.checkUserEnabled();
    }
    if (this._dataService.hasReadOnlyAccess) {
      this.readonlyAccess = true;
    }
    this.hasAccessEE = this._dataService.userType === (UserType.ELECTRICAL_ENGINEERING) || this._dataService.userType === (UserType.MARKETING) || this._dataService.userType === (UserType.SUPER_ADMIN);
    this.hasAccessME = this._dataService.userType === (UserType.MECHANICAL_ENGINEERING) || this._dataService.userType === (UserType.MARKETING) || this._dataService.userType === (UserType.SUPER_ADMIN);
    this.hasAccessPM = this._dataService.userType === (UserType.PROJECT_MANAGEMENT) || this._dataService.userType === (UserType.MARKETING) || this._dataService.userType === (UserType.SUPER_ADMIN);
    if (!this.dsAnnuciatorObj.parentSORef.isDatasheetSubOrderEnabled) {
      this.lockFields = false;
    }
    else {
      this.lockFields = true;
    }

  }

  addNewSurgArrBlock() {
    this.dsAnnuciatorObj.addAnnunciatorDS(new MultiOptDetails_5DS("", "", "", "", ""));
  }
  removeSurgArrBlock(_srDS: MultiOptDetails_5DS) {
    if (_srDS) {
      this.dsAnnuciatorObj.removeAnnunciatorDS(_srDS);
    }
  }

  onApplicabilityChange(_anM:MultiOptDetails_5DS): boolean {
    if(_anM.type2)
      if(_anM.type2 == "001") { // When type2 is 'Applicable'
      return true;
    }
    else{
      _anM.type3 = "";
      _anM.type4 = "";
      _anM.type5 = "";
    return false;
    }
  }
  onCommunicableChange(_anM:MultiOptDetails_5DS): boolean {
    if(_anM.type4)
      if(_anM.type4 == "yes") { // When type4 is 'Yes'
      return true;
    }
    else{
      _anM.type5 = "";
      return false;
    }
  }

sectionNoteChangePM(_event: any) {
    this.dsAnnuciatorObj.sectionNotePM = _event.target.value;
  }
  sectionNoteChangeEE(_event: any) {
    this.dsAnnuciatorObj.sectionNoteEE = _event.target.value;
  }
  sectionNoteChangeME(_event: any) {
    this.dsAnnuciatorObj.sectionNoteME = _event.target.value;
  }

  saveDS(_submitToNextSection: boolean) {
    if (this.updateDatasheet) {
      this.updateDatasheet.emit(new SaveStatusObj(SOModule.Marketing,
        (_submitToNextSection == true ? SaveEventType.Submit_To_Next : SaveEventType.Save_Data)));
    }
  }
  reloadData() {
    if (this.updateDatasheet) {
      this.updateDatasheet.emit(new SaveStatusObj(SOModule.Marketing, SaveEventType.Reload_Data));
    }
  }

  showSoValidation() {
    let _validList: Array<ValidationItem> = [];

    if (this.hasAccessEE) {
      // if (this.dsAnnuciatorObj.annunciator_Enable) {
        // for (let i = 0; i < this.dsAnnuciatorObj.annunciatorData.length; i++) {
        //   let an = this.dsAnnuciatorObj.annunciatorData[i];
        //   _validList.push(
        //     new ValidationItem("Annunciator #" + (i + 1), !!an.type1, " required to save Datasheet."),
        //     new ValidationItem("Applicability #" + (i + 1), !!an.type2, " required to save Datasheet.")
        //   );
        //   if (an.type2 == "001") {
        //     _validList.push(
        //       new ValidationItem("Annunciator Type #" + (i + 1), !!an.type3, " required to save Datasheet."),
        //       new ValidationItem("Communicable #" + (i + 1), !!an.type4, " required to save Datasheet.")
        //     );
        //     if (an.type4 == "yes") {
        //       _validList.push(new ValidationItem("Communication Port #" + (i + 1), !!an.type5, " required to save Datasheet."));
        //     }
        //   }
        // }
      // }
      _validList.push(new ValidationItem("EE Note", !!this.dsAnnuciatorObj.sectionNoteEE, " required to save Datasheet."));
    }
    if (this.hasAccessPM) {
      _validList.push(new ValidationItem("PM Note", !!this.dsAnnuciatorObj.sectionNotePM, " required to save Datasheet."));
    }
    if (this.hasAccessME) {
      _validList.push(new ValidationItem("ME Note", !!this.dsAnnuciatorObj.sectionNoteME, " required to save Datasheet."));
    }

    let vSummaryObj: ValidationSummary = new ValidationSummary("Validation Summary.", _validList);
    this.dialog.open(ValidationDialog, { width: '50%', data: vSummaryObj });
  }

  saveSOValidation(): boolean {
    if (this.hasAccessEE) {
      // if (this.dsAnnuciatorObj.annunciator_Enable) {
        // for (let an of this.dsAnnuciatorObj.annunciatorData) {
        //   if (!an.type1 || !an.type2) return false;
        //   if (an.type2 == "001") {
        //     if (!an.type3 || !an.type4) return false;
        //     if (an.type4 == "yes" && !an.type5) return false;
        //   }
        // }
      // }
      if (!this.dsAnnuciatorObj.sectionNoteEE) return false;
    }
    if (this.hasAccessPM) {
      if (!this.dsAnnuciatorObj.sectionNotePM) return false;
    }
    if (this.hasAccessME) {
      if (!this.dsAnnuciatorObj.sectionNoteME) return false;
    }
    return true;
  }
}


